@use "sass:color" as sassColor;
@use "../../styling/colors.scss" as *;
@use "../../styling/typography.scss" as *;

$status-color: "fail"$color-primary-red-hover $color-primary-red-hover 0.6,
  "pass"$color-secondary-green $color-secondary-green 0.4,
  "cancelled"$color-grey-disabled $color-secondary-button-border 0.2,
  "error"$color-warning-orange $color-warning-orange 0.2,
  "pending"$color-grey-B $color-secondary-button-border 0.2,
  "inProgress"$color-primary-purple $color-primary-purple 0.2;

.StatusChipButton {
  @extend %font-family-primary;

  font-size: $font-size-normal;
  font-weight: $font-weight-semibold;
  display: inline-flex;
  align-items: center;
  column-gap: 6px;
  padding: 4px 8px;
  cursor: pointer;
  border-radius: 6px;
  border-style: solid;
  border-width: 1px;

  a {
    text-decoration: none !important;
    color: $theme-color-text;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    column-gap: 6px;
  }

  @each $name,
  $color,
  $border-color,
  $opacity in $status-color {
    &.#{$name} {
      border-color: sassColor.adjust($border-color, $alpha: -$opacity);
      background-color: transparent;

      svg {
        fill: $color;
      }
    }
  }

  &.cancelled,
  &.pending {
    border-color: $color-secondary-button-border;
  }

  &:hover {
    background: $theme-color-background;
  }

  &:focus-within,
  &:focus,
  &:active {
    background: $theme-color-secondary-button-active;
  }
}